import { c as _c } from "react/compiler-runtime";
import { TripCollection } from "@website/icons/components/trip-collection";
import { Accordion } from "@website/ui/accordion";
import Link from "next/link";
import { FC } from "react";
import { CMSLinkGroup, InboundLinksType } from "./inbound-links.types";
const InboundLinkItem = t0 => {
  const $ = _c(4);
  const {
    links
  } = t0;
  let t1;
  if ($[0] !== links) {
    t1 = links.map(_temp);
    $[0] = links;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="text-on-surface-high-emphasis flex w-full flex-col gap-3">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const masonryList = (list: Array<CMSLinkGroup>) => {
  const result: Array<Array<CMSLinkGroup>> = [[], [], []];
  for (const [index, element] of list.entries()) {
    const columnIndex = index % 3;
    result[columnIndex]?.push(element);
  }
  return result;
};
export const InboundLinks: FC<InboundLinksType> = t0 => {
  const $ = _c(17);
  const {
    title,
    linksData
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== linksData || $[1] !== title) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const validLinks = linksData.filter(_temp2);
      if (validLinks.length === 0) {
        t5 = null;
        break bb0;
      }
      t3 = "w-full py-8";
      let t6;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <TripCollection className="fill-on-surface-medium-emphasis text-xl" />;
        $[7] = t6;
      } else {
        t6 = $[7];
      }
      if ($[8] !== title) {
        t4 = <header className="mb-4 flex h-8 flex-row items-center gap-2">{t6}<h2 className="text-on-surface-high-emphasis lg:text-headline-6 text-base">{title}</h2></header>;
        $[8] = title;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t1 = "grid items-start gap-4 xl:grid-cols-3";
      t2 = masonryList(validLinks)?.map(_temp4);
    }
    $[0] = linksData;
    $[1] = title;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <section className={t3}>{t4}{t6}</section>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp(item) {
  return <Link className="underline-offset-8 hover:underline" href={item.linkValue} key={item.linkTitle} prefetch={false}>{item.linkTitle}</Link>;
}
function _temp2(group) {
  return group.LinksTitle && group.links && group.links.length > 0;
}
function _temp3(linkGroup) {
  return <Accordion content={linkGroup.links.length > 0 ? <InboundLinkItem links={linkGroup.links} /> : ""} initialExpanded={true} key={linkGroup.LinksTitle} scroll="long" title={linkGroup.LinksTitle || ""} />;
}
function _temp4(column, index) {
  return <div className="grid gap-4" key={`InboundLinks-${index++}`}>{column.map(_temp3)}</div>;
}